import { render, staticRenderFns } from "./MunicipioDetalhes.vue?vue&type=template&id=0ec8cf74"
import script from "./MunicipioDetalhes.vue?vue&type=script&lang=js"
export * from "./MunicipioDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports